<template>
	<div>
		<div class="block-wrap bread-wrap">
			<Breadcrumbs :routes="breadRoutes" />
		</div>
		<div class="content-wrap">
			<section class="main-wrap">
				<section class="main-content">
					<h2 class="main-title">{{detailInfo._title}}</h2>
					
					<div class="main-content-box ckeditor-wrap" v-html="detailInfo._content"></div>
				</section>
			</section>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import router from '@/router';
import Breadcrumbs from "@/components/Breadcrumbs";
import { getCouncilDetail, getGreatDetail, getInstitutionDetail, getClientDetail } from './service/api';

const routeMap = {
	council: {
		api: getCouncilDetail,
		format: res => {
			res._title = res.councilTitle;
			res._content = res.councilContent || '';
			return res;
		}
	},
	great: {
		api: getGreatDetail,
		format: res => {
			res._title = res.eventTitle;
			res._content = res.eventContent || '';
			return res;
		}
	},
	institution: {
		api: getInstitutionDetail,
		format: res => {
			res._title = res.institutionTitle;
			res._content = res.institutionContent || '';
			return res;
		}
	},
	client: {
		api: getClientDetail,
		format: res => {
			res._title = '浙江省风景园林学会章程';
			res.createHumanName = '管理员';
			res.viewCnt = '9999';
			res._content = res.content;
			res.releaseDate = 1640995200;
			return res;
		}
	}
}

export default {
	data() {
		return {
			breadRoutes: [{
    		href: '/',
    		name: '首页'
    	}, {
    		name: '关于我们'
    	}],
			detailInfo: {}
		}
	},
	components: {
		Breadcrumbs
	},
	mounted() {
		const mId = router.currentRoute.params.id;
		this.module = routeMap[mId];
		this.queryId = router.currentRoute.query.aId;
		this.getDetail();
	},
	methods: {
		getDetail() {
			this.module.api({
				id: this.queryId
			}).then(res => {
				res = this.module.format(res);
				const date = moment(res.releaseDate*1000).format('YYYY-MM-DD');
				this.detailInfo = { 
					...res,
					_releaseDate: date
				};
			})
		}
	}
}
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';
.notice-detail {
	background: #F9F9F9;

	.bread-wrap {
		padding-top: 12px;
	}
}
.content-wrap {
	position: relative;
	background: #ffffff;
	width: @middleWidth;
	margin-left: auto;
	margin-right: auto;

	.left-wrap {
		position: absolute;
		left: 20px;
		top: 60px;

		.time-box {
			display: flex;
			flex-direction: column;
			align-items: center;

			&-y {
				height: 16px;
				font-size: 18px;
				font-family: DINAlternate-Bold, DINAlternate;
				font-weight: bold;
				color: #131415;
				line-height: 16px;
				margin-bottom: 10px;
			}

			&-d {
				height: 28px;
				font-size: 28px;
				font-family: DINAlternate-Bold, DINAlternate;
				font-weight: bold;
				color: #131415;
				line-height: 28px;
				margin-bottom: 5px;
			}

			&-h {
				height: 16px;
				font-size: 18px;
				font-family: DINAlternate-Bold, DINAlternate;
				font-weight: bold;
				color: #131415;
				line-height: 16px;
			}
		}
	}
	.main-wrap {
		width: 782px;
		min-height: 600px;
		margin-left: 134px;
		padding-top: 60px;
		padding-bottom: 73px;

		.main-content {
			width: 100%;
			margin: 0 auto;

			.main-title {
				// width: 696px;
				font-size: 40px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #131415;
				line-height: 40px;
				text-align: center;
				margin-bottom: 10px;
			}
			.download-warp {
        margin-top: 30px;
        
        > div {
          display: flex;
          border-bottom: 1px solid #06AE63;
          align-items: center;
          padding-right: 10px;

          .download-title {
            background: url(../../assets/images/active-detail-down-bg.png) no-repeat center center;
            background-size: 100% 100%;
            padding: 12px 16px;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 18px;
          }

          .download-name {
            width: 486px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #06AE63;
            line-height: 20px;
          }

          .download-op {
            margin-left: auto;
            padding-left: 28px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131415;
            background: url(../../assets/images/icon-download.png) no-repeat 0 center;
            background-size: 24px 24px;
          }
        }
      }
			.main-info {
				height: 14px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #9D9E9E;
				line-height: 14px;
				text-align: center;

				span {
					margin-right: 40px;
					position: relative;

					&:last-child {
						margin-right: 0;

						&::after {
							display: none;
						}
					}

					&::after {
						content: '';
						position: absolute;
						width: 1px;
						height: 14px;
						background: #D8D8D8;
						right: -19px;
						top: 2px;
					}
				}
			}
			.main-content-box {
				padding-top: 80px;
			}
		}

		.block-title {
			margin-top: 30px;
			padding-left: 26px;
			margin-bottom: 30px;
			background: url(../../assets/images/active-block-title-bg.png) no-repeat 0 center;
			background-size: 17px 14px;
			height: 20px;
			font-size: 20px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #131415;
			line-height: 20px;
		}

		.download-wrap {
			border-radius: 4px;
			padding: 0 20px 0 24px;
			border: 1px solid #06AE63;
			background-color: #fafafa;

			> div {
				display: flex;
				align-items: center;
				height: 64px;
				background: #FAFAFA;
			}

			.download-file-icon {
				height: 24px;
				margin-right: 12px;
			}

			.download-title {
				font-size: 18px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #06AE63;
				width:85%;
			}

			.download-op {
				margin-left: auto;
				padding-left: 28px;
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #131415;
				background: url(../../assets/images/icon-download.png) no-repeat 0 center;
        background-size: 24px 24px;
			}
		}
	}
	.right-wrap {
		width: 210px;
		position: absolute;
		right: 13px;
		top: 74px;

		.num-box {
			width: 131px;
			height: 78px;
			margin: 0 auto 120px;
			background: #ffffff;
			display: flex;
			flex-direction: column;

			&-y {
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #131415;
				line-height: 18px;
				border-radius: 8px 8px 0 0;
				border: 1px solid #9D9E9E;
				border-bottom: none;
			}

			&-no {
				height: 38px;
				background: #06AE63;
				font-size: 24px;
				font-family: DINAlternate-Bold, DINAlternate;
				font-weight: bold;
				color: #FFFFFF;
				line-height: 38px;
				text-align: center;
				border-radius: 0 0 8px 8px;
				border-top: none;
			}
		}
		.other-list {
			&-header {
				height: 28px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 26px;

				img {
					width: 80px;
				}

				.more-btn {
					height: 14px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #9D9E9E;
					line-height: 14px;
					cursor: pointer;
				}
			}

			&-wrap {

				.other-list-item {
					position: relative;
					padding: 0 20px;

					&::before {
						content: '';
						width: 6px;
						height: 6px;
						background: #06AE63;
						border-radius: 50%;
						position: absolute;
						left: 9px;
						top: 4px;
					}

					&:hover {
						&-title {
							color: #06AE63;
						}					
					}
					
					&-title {
						&:extend(.line1);
						width: 196px;
						height: 14px;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #131415;
						line-height: 14px;
						margin-bottom: 10px;
					}

					&-time {
						height: 14px;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #787878;
						line-height: 14px;
					}
				}
			}
		}
	}
}
</style>